// extracted by extract-css-chunks-webpack-plugin
module.exports = {"icon-main":"Qd1LH","iconPath":"d0Wo3"};